import { FiArrowRight } from "react-icons/fi";
import { t, useI18n } from "../utils/i18n";
import "./HomeToolList.css";

const TOOLS = [
  {
    id: "grimoire",
    numeral: "I",
    image: "/images/jolymei-grimoire-object-v3.png",
    titleKey: "home.tools.grimoire.title",
    kindKey: "home.tools.grimoire.kind",
    bodyKey: "home.tools.grimoire.body",
    path: "/grimoire",
    accent: "96, 165, 250",
    titleColor: "#bfdbfe",
  },
  {
    id: "sigil",
    numeral: "II",
    image: "/images/jolymei-sigil-object-v3.png",
    titleKey: "home.tools.flowchart.title",
    kindKey: "home.tools.flowchart.kind",
    bodyKey: "home.tools.flowchart.body",
    path: "/sigil",
    accent: "52, 211, 153",
    titleColor: "#a7f3d0",
  },
];

/** Homepage tool entries, set side by side as two volumes on a shelf. The
    whole volume is the click target (the button's ::after covers it);
    HomePage retains the auth-aware navigation. */
export default function HomeToolList({ onOpen }) {
  const { language } = useI18n();
  const translate = (key) => t(key, language);

  return (
    <div className="home-volumes">
      {TOOLS.map((tool) => {
        const title = translate(tool.titleKey);

        return (
          <article
            key={tool.id}
            className="home-volume"
            style={{ "--tool-accent": tool.accent, "--tool-title": tool.titleColor }}
            aria-labelledby={`home-tool-${tool.id}`}
          >
            <div className="home-volume-art" aria-hidden="true">
              <img src={tool.image} alt="" width="1254" height="1254" loading="lazy" />
            </div>
            <p className="home-volume-kind">
              <span className="home-volume-numeral">{tool.numeral}</span>
              {translate(tool.kindKey)}
            </p>
            <h3 id={`home-tool-${tool.id}`}>{title}</h3>
            <p className="home-volume-body">{translate(tool.bodyKey)}</p>
            <button type="button" className="home-volume-open" onClick={() => onOpen(tool.path)}>
              <span>{translate("home.tools.open_named").replace("{name}", title)}</span>
              <FiArrowRight aria-hidden="true" />
            </button>
          </article>
        );
      })}
    </div>
  );
}
